<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>Veranstaltung</span>
			</div>

			<mat-spinner diameter=30 [ngStyle]="{ opacity: bCommInProgress ? 1 : 0 }" />

		</div>

		<div style="padding:1em; margin: 0em auto 0 auto; position: relative">

			<div *ngIf="!bFirstLoading" class="mainCol">

				<div class="twoFields">
					<div>
						<div class="label">Anfang</div>
						<div>
							{{ event.tmsStart | date: "dd.MM.YYYY HH:mm" }}
						</div>
					</div>

					<div>
						<div class="label">Ende</div>
						<div>
							{{ event.tmsEnd | date: "dd.MM.YYYY HH:mm" }}
						</div>
					</div>
				</div>

				<div>
					<div class="label">Ort</div>
					<div>
						{{ event.place }}
					</div>
				</div>

				<div>
					<div class="label">Gruppen</div>
					<div>
						{{ groupNames }}
					</div>
				</div>

				<div>
					<div class="label">Anmeldefrist</div>
					<div>
						<ng-container *ngIf="event.tmsRegisterUntil; else noRegistrationDeadline">
							{{ event.tmsRegisterUntil | date: "dd.MM.YYYY HH:mm" }}
							<span *ngIf="registrationDeadlinePassed"> (abgelaufen)</span>
						</ng-container>
						<ng-template #noRegistrationDeadline>-</ng-template>
					</div>
				</div>

				<div>
					<div class="label">Veranstaltungsname</div>
					<div>
						{{ event.name }}
					</div>
				</div>

				<div>
					<div class="label">Beschreibung</div>
					<div class="htmlViewer" [innerHTML]="domSanitizer.bypassSecurityTrustHtml( event.description )"></div>
				</div>

				<div *ngIf="attachedFiles.length">

					<div class="label">Angehängte Dateien</div>

					<div
						*ngFor="let attachedFile of attachedFiles"
						class="fileLine"
					>
						<div class="fileNameAndDelete">
							<span
								class="fileName"
								(click)="downloadFile(attachedFile)"
							>
								{{attachedFile.file.name}}
							</span>
						</div>

					</div>

				</div>

				<ng-container *ngIf="bAdmin">
					<div>
						<div class="label">Erinnerungs-E-Mail geplant</div>
						<div>
							{{ event.tmsReminderMail ? (event.tmsReminderMail | date: "dd.MM.YYYY HH:mm") : '-' }}
						</div>
					</div>

					<div>
						<div class="label">Erinnerungsstatus</div>
						<div>
							{{ event.bReminderMailSent ? 'Erinnerung wurde versendet' : 'Erinnerung wurde noch nicht versendet' }}
						</div>
					</div>
				</ng-container>


				@if( bAdmin ) {
					<div>
	
						<div class="label">Registrierte Benutzer</div>
	
						@if( !event.assignedUsers.length ) {
							<div class="noElements">Keiner</div>
						}
						@else {

							<div class="sublabelLine">Angemeldet:</div>
		
							<ul>
								@if( !yesUserIds.length ) {
									<li>Keiner</li>
								}
								@for( userId of yesUserIds; track userId ) {
									<li>	
										<div class="subscribedUser">
			
											<span>{{ mitgliedsnameCache[ userId ] || 'Unbekannt' }}</span>
											<span> - </span>
											<span>{{usernameCache[ userId ]}}</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="seeRegistration( userId )"
												title="Anmeldung visualisieren"
											>
												description
											</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="clickKickUser( userId )"
												title="Benutzer abmelden"
											>
												logout
											</span>
			
										</div>
									</li>
								}
							</ul>
		
							<div class="sublabelLine">Nicht angemeldet:</div>
		
							<ul>
								@if( !noUserIds.length ) {
									<li>Keiner</li>
								}
								@for( userId of noUserIds; track userId ) {
									<li>	
										<div class="subscribedUser">
			
											<span>{{ mitgliedsnameCache[ userId ] || 'Unbekannt' }}</span>
											<span> - </span>
											<span>{{usernameCache[ userId ]}}</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="seeRegistration( userId )"
												title="Anmeldung visualisieren"
											>
												description
											</span>
			
											<span
												class="material-icons kickBtn"
												[ngClass]="{ 'disabledBtn' : bCommInProgress }"
												(click)="clickKickUser( userId )"
												title="Benutzer abmelden"
											>
												logout
											</span>
			
										</div>
									</li>
								}
							</ul>

							<button
								mat-raised-button
								color="primary"
								(click)="downloadFormAnswer()"
							>
								CSV Export
							</button>
						}
	
					</div>
				}

				
				<div class="download-ics label">
					<span (click)="downloadICSFile()">Download ICS File  </span>
					<mat-icon (click)="downloadICSFile()" id="downloadIcsFileButton">download</mat-icon>
				</div>

				<div *ngIf="!bAdmin">
					<div class="label">Mein Status</div>
					<div>
						{{ registrationStatusLabel }}
						<span *ngIf="registrationDeadlinePassed">- Anmeldefrist abgelaufen</span>
					</div>
				</div>

				<div *ngIf="!bAdmin && hasResponded">
					<span class="label" (click)="seeMyRegistration()" id="antwortenTxt">Antworten  </span>
					<span
						class="material-icons kickBtn"
						[ngClass]="{ 'disabledBtn' : bCommInProgress }"
						(click)="seeMyRegistration()"
						title="Antwort anzeigen"
					>
						description
					</span>
				</div>


				<ng-container *ngIf="!bAdmin">

					<button
						*ngIf="canShowRegistrationAction"
						mat-raised-button
						color="primary"
						[disabled]="bCommInProgress || registrationDeadlinePassed"
						(click)="registerToEvent()"
						style="font-family: 'Passion One'; font-size: x-large;"
					>
						<span class="material-icons" style="margin-right: .5em">{{ registrationButtonIcon }}</span>
						{{ registrationButtonLabel }}
					</button>

					<button
						*ngIf="registrationDeadlinePassed && !hasResponded"
						mat-raised-button
						[disabled]="true"
						style="font-family: 'Passion One'; font-size: x-large;"
					>
						Registrierungszeitraum abgelaufen
					</button>

				</ng-container>

				<!--
					(click)="unsubscribeToEvent()"
					<span class="material-icons" style="margin-left: .5em">logout</span>
				-->

			</div>

		</div>

	</div>

</div>

